import { useCallback, useEffect, useState } from "react";

import { switchTenantRequest } from "../../../../services/Users/api";
import { showError } from "../../../../utils/sagasErrorHandler";

const useTenants = (user) => {
    const [ currentTenantCode, setCurrentTenantCode ] = useState(null);
    const [ tenants, setTenants ] = useState([]);

    const handleSwitch = useCallback(
        async (code) => {
            try {
                await switchTenantRequest(code);

                window.location.reload();
            } catch (error) {
                showError(error);
            }
        },
        []
    );

    useEffect(
        () => {
            if(user && user.user_to_tenants) {
                setTenants(user.user_to_tenants);
            }

            if(user && user.tenant_code) {
                setCurrentTenantCode(user.tenant_code);
            }
        },
        [ user ]
    );

    return {
        tenants,
        currentTenantCode,
        handleSwitch
    };
};

export default useTenants;
